import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { getCalendarConnections } from '../../api/crmApi';

import { calendarKeys } from './keys';

export const calendarConnectionsOptions = () =>
	queryOptions({
		queryKey: calendarKeys.connections(),
		queryFn: async () => {
			const res = await getCalendarConnections();
			return res.connections ?? [];
		},
		staleTime: STALE_TIMES.FREQUENT,
	});

export function useCalendarConnections() {
	return useQuery(calendarConnectionsOptions());
}
